import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spinner, WarningCircle } from "@phosphor-icons/react";
import { supplierApi } from "@/lib/supplierPortalApi";
import { useSupplierAuth } from "@/contexts/SupplierAuthContext";

// Oct 12 2026, QMS -> Materials Hub sign-on link (handover contract
// section 3). QMS redirects the supplier's browser here with a
// short-lived token; only a real backend call can set the httpOnly
// session cookie, so this page's only job is to exchange the token
// then forward the supplier into the app at `next`.
export default function SupplierSSOLandingPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useSupplierAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token");
    const next = params.get("next") || "/supplier-portal";
    if (!token) {
      setError("Missing sign-on token.");
      return;
    }
    (async () => {
      try {
        await supplierApi.post("/sso-exchange", { token });
        await refresh();
        navigate(next, { replace: true });
      } catch (e) {
        setError(e.response?.data?.detail || "This sign-on link is invalid or has expired.");
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-4" data-testid="supplier-sso-landing-page">
      <div className="text-center max-w-sm">
        {error ? (
          <>
            <WarningCircle size={32} className="text-[#991B1B] mx-auto mb-3" weight="fill" />
            <p className="text-sm text-[#991B1B] font-semibold" data-testid="supplier-sso-error">{error}</p>
            <a href="/supplier-portal/login" className="text-sm text-[#1E40AF] underline mt-3 inline-block">Go to login</a>
          </>
        ) : (
          <>
            <Spinner size={32} className="text-[#1E40AF] mx-auto mb-3 animate-spin" />
            <p className="text-sm text-slate-600">Signing you in...</p>
          </>
        )}
      </div>
    </div>
  );
}
